import UsersView from './users/UsersView';

/**
 * 用户管理标签页（P4.3）。
 *
 * ⚠️ P4.2 占位导出名保持不变（default UsersPanel）。
 *    真实实现收敛在 features/settings/users/。
 *    权限：user:manage；数据源：GET /api/system/users。
 *
 * 外层 .p43-users 用于把弹窗兜底样式（.pm-modal*）作用域收敛在本特性内，
 * 避免影响其它页面。
 */
export default function UsersPanel() {
  return (
    <div className="p43-users">
      <UsersView />
    </div>
  );
}
